module.exports = __webpack_public_path__ + "static/img/2.99a16a5b.png";